module.exports = __webpack_public_path__ + "assets/img/35_1118_big.6f12a3d3.jpg";